(function() {
    angular
        .module('emarket.commons')
        .factory('ProvinceChooser', ['$rootScope', '$log', '$q', '$timeout', '$mdDialog', '$cookies', '$mdPanel', '$mdMedia', 'Announcer', function($rootScope,
            $log,
            $q,
            $timeout,
            $mdDialog,
            $cookies,
            $mdPanel,
            $mdMedia,
            Announcer) {
            var announcer = Announcer.createEmitter();
            var types = {
                PROVINCE_KEY: 'province',
                FIRST_TIME_KEY: 'first-time',
                FIRST_TIME_VALUE: 'first-time-value'
            };
            var callback;
            var isMobile = $mdMedia('xs') || $mdMedia('sm');
            var setCookie = function(province) {
                if (province) {
                    $cookies.putObject(types.PROVINCE_KEY, {
                        name: province.name,
                        _id: province._id,
                        slug: province.slug
                    });
                    if (callback) {
                        callback(province);
                    }
                } else {
                    $cookies.putObject(types.PROVINCE_KEY, null);
                    if (callback) {
                        callback(null);
                    }
                }
            };
            var isFirstTime = function() {
                return $cookies.get(types.FIRST_TIME_KEY) !== types.FIRST_TIME_VALUE;
            };
            var clearFirstTime = function() {
                $cookies.remove(types.FIRST_TIME_KEY);
            };
            var setFirstTime = function() {
                $cookies.put(types.FIRST_TIME_KEY, types.FIRST_TIME_VALUE);
            };
            var openMobileToast = function() {
                var defer = $q.defer();
                var that = this;
                var panelPosition = $mdPanel
                    .newPanelPosition()
                    .absolute()
                    .bottom('0')
                    .left('0');
                $mdPanel.open({
                    templateUrl: 'directives/province/province.chooser.panel.tpl.html',
                    position: panelPosition,
                    focusOnOpen: true,
                    controllerAs: 'vm',
                    hasBackdrop: true,
                    panelClass: 'province-chooser-panel__container',
                    controller: [
                        'mdPanelRef',
                        function(mdPanelRef) {
                            var vm = this;

                            vm.close = function() {
                                mdPanelRef.close($mdPanel.closeReasons.CLICK_OUTSIDE);
                            };
                            announcer.emit(Announcer.types.FULL_SCREEN_MODE);
                            vm.open = function() {
                                mdPanelRef.close();
                                that
                                    .open()
                                    .then(function(province) {
                                        announcer.emit(Announcer.types.FULL_SCREEN_MODE_NO_TOOLBAR, false);
                                        announcer.emit(Announcer.types.FULL_SCREEN_MODE, false);
                                        defer.resolve(province);
                                    })
                                    .catch(function(err) {
                                        announcer.emit(Announcer.types.FULL_SCREEN_MODE_NO_TOOLBAR, false);
                                        announcer.emit(Announcer.types.FULL_SCREEN_MODE, false);
                                        defer.reject(err);
                                    });
                            };
                        }
                    ],
                    onCloseSuccess: function(panelRef, reason) {
                        if (reason === $mdPanel.closeReasons.CLICK_OUTSIDE) {
                            announcer.emit(Announcer.types.FULL_SCREEN_MODE, false);
                            // TODO: do something
                        }
                    }
                });
                return defer.promise;
            };
            $rootScope.$on('$stateChangeSuccess', function() {
                if (callback) {
                    callback = null;
                }
            });
            return {
                get: function() {
                    return $cookies.getObject(types.PROVINCE_KEY);
                },
                set: setCookie,
                isFirstTime: isFirstTime,
                clearFirstTime: clearFirstTime,
                openMobileToast: openMobileToast,
                onChange: function(cb) {
                    callback = cb;
                },
                openFirstTime: function() {
                    return $q(function(resolve) {
                        if (isFirstTime()) {
                            setFirstTime();
                            if (isMobile) {
                                $timeout(function() {
                                    this.openMobileToast().then(function(province) {
                                        resolve(province);
                                    });
                                }.bind(this),
                                10000);
                            } else {
                                $timeout(function() {
                                    this.open().then(function(province) {
                                        resolve(province);
                                    });
                                }.bind(this),
                                60000);
                            }
                        } else {
                            return resolve();
                        }
                    }.bind(this));
                },
                open: function() {
                    setFirstTime();
                    return $mdDialog
                        .show({
                            templateUrl: 'directives/province/province.chooser.dialog.tpl.html',
                            controller: [
                                '$mdDialog',
                                'Province',
                                function($mdDialog, Province) {
                                    var vm = this;
                                    vm.isLoading = true;
                                    vm.selected = $cookies.getObject(types.PROVINCE_KEY);
                                    vm.close = function() {
                                        $mdDialog.cancel();
                                    };
                                    Province.$search()
                                        .$asPromise()
                                        .then(function(provinces) {
                                            vm.provinces = provinces;
                                            vm.isLoading = false;
                                        })
                                        .catch(function() {
                                            vm.isLoading = false;
                                        });
                                    vm.chooseProvince = function(province) {
                                        $mdDialog.hide(province);
                                    };
                                }
                            ],
                            controllerAs: 'vm'
                        })
                        .then(function(province) {
                            setCookie(province);
                            return province;
                        });
                }
            };
        }]);
}());
